import { axiosMock } from '@api/client';
import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from '../apiDictionary';
import { USE_API_MOCKS } from '../../env';
import { createRandomDXAScoring } from 'src/mocks/dxaScoring';

export type CalculateDXAScoringType = {
  clinicalTrialId: string;
  taskId: string;
  body: {
    comment: string;
    selectedLabels: string[];
  };
};

export const calculateDXAScoringMocks = (args: CalculateDXAScoringType) => {
  if (!USE_API_MOCKS) {
    return;
  }

  const data = createRandomDXAScoring();

  axiosMock
    .onPut(prepareUrl(API_URL.readerTaskCalculate, [args?.taskId]))
    .reply(200, JSON.stringify(data));
};
